module.exports = __webpack_public_path__ + "img/await.32c15571.svg";